import React from 'react';
import FaqItem from './FaqItem';

const FaqList = ({ topics, sectionRefs, faqItemRefs, openFaqId }) => {
  return (
    <div className='flex flex-col items-start py-20 max-w-[980px] w-full gap-[100px]'>
      {topics.map((topic) => (
        <section
          key={topic.id}
          data-slug={topic.slug}
          ref={(el) => (sectionRefs.current[topic.slug] = el)}
          className='w-full flex flex-col gap-6'
        >
          <div className='flex flex-start px-[18px] gap-[10px] typo-b18Strong text-text-primary text-left italic'>
            {topic.title}
          </div>

          <div>
            {topic.faqs.map((faq) => (
              <FaqItem
                key={faq.id}
                faq={faq}
                faqItemRefs={faqItemRefs}
                isForceOpen={openFaqId === faq.id}
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default FaqList;
